import { BinaryWriter } from "../binary.js";
import { ClientOp, ServerOp } from "../opcodes.js";
export function encodeCast(packet, writer = new BinaryWriter(16)) {
    writer
        .u8(ClientOp.Cast)
        .u16(packet.spellId)
        .u32(packet.targetId)
        .u16(packet.x)
        .u16(packet.y);
    return writer;
}
export function decodeCast(reader) {
    return {
        spellId: reader.u16(),
        targetId: reader.u32(),
        x: reader.u16(),
        y: reader.u16(),
    };
}
export function encodeEffect(packet, writer = new BinaryWriter(64)) {
    writer.u8(ServerOp.Effect).u8(packet.points.length);
    for (const point of packet.points) {
        writer.u8(point.effectId).u16(point.x).u16(point.y).u8(point.z);
    }
    writer.u8(packet.shots.length);
    for (const shot of packet.shots) {
        writer
            .u8(shot.effectId)
            .u16(shot.fromX)
            .u16(shot.fromY)
            .u16(shot.toX)
            .u16(shot.toY)
            .u8(shot.z);
    }
    return writer;
}
export function decodeEffect(reader) {
    const pointCount = reader.u8();
    const points = new Array(pointCount);
    for (let i = 0; i < pointCount; i++) {
        points[i] = {
            effectId: reader.u8(),
            x: reader.u16(),
            y: reader.u16(),
            z: reader.u8(),
        };
    }
    const shotCount = reader.u8();
    const shots = new Array(shotCount);
    for (let i = 0; i < shotCount; i++) {
        shots[i] = {
            effectId: reader.u8(),
            fromX: reader.u16(),
            fromY: reader.u16(),
            toX: reader.u16(),
            toY: reader.u16(),
            z: reader.u8(),
        };
    }
    return { points, shots };
}
//# sourceMappingURL=cast.js.map